import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "../utils/api";

const TYPE_TO_PATH = {
  incident: "incidents",
  service_request: "service-requests",
  change_request: "change-requests",
  problem: "problems",
};

export default function OverdueWork() {
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/api/dashboard/overdue").then((r) => setGroups(r.data.groups || [])); }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <AlertTriangle className="text-red-600" />
        <h1 className="text-2xl font-bold">Overdue Work</h1>
      </div>

      {groups.length === 0 && <div className="card p-6 text-center text-gray-500">Nothing overdue. Nice work.</div>}

      {groups.map((g) => (
        <div key={g.assignee} className="card p-5">
          <h2 className="font-semibold mb-3">{g.assignee} <span className="text-sm text-gray-500">({g.items.length})</span></h2>
          <table className="w-full text-sm">
            <thead className="text-left text-gray-600">
              <tr><th className="p-2">#</th><th className="p-2">Type</th><th className="p-2">Title</th><th className="p-2">Status</th><th className="p-2">Plant</th><th className="p-2">Created</th><th className="p-2">Deadline</th></tr>
            </thead>
            <tbody>
              {g.items.map((it) => (
                <tr key={`${it.type}-${it.id}`} className="border-t">
                  <td className="p-2 font-mono text-xs">
                    <Link to={`/${TYPE_TO_PATH[it.type]}/${it.id}`} className="text-brand-600 hover:underline">{it.number}</Link>
                  </td>
                  <td className="p-2">{it.type.replace("_", " ")}</td>
                  <td className="p-2">{it.title}</td>
                  <td className="p-2"><span className="badge bg-gray-100 text-gray-700">{it.status}</span></td>
                  <td className="p-2">{it.plant}</td>
                  <td className="p-2 text-xs text-gray-500">{it.created_at && new Date(it.created_at).toLocaleDateString()}</td>
                  <td className="p-2 text-xs text-red-600">{it.deadline && new Date(it.deadline).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
